export default __webpack_public_path__ + "static/media/showLess.429c0a3b.svg";